import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from "@angular/router";
import {RegistroComponent} from "./registro.component";

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [RegistroComponent],
  exports: [RegistroComponent]
})
export class RegistroModule { }



// WEBPACK FOOTER //
// ./src/app/components/registro/registro.module.ts